<template>
  <Modal @opened="opened($event)" @closed="closed()" :size="'xl'" :modalId="modalId">
    <template #header>
      <div class="ifttt-header">
        <div class="ifttt-header-info" v-if="iftttId && getAutomationById(iftttId)">
          {{  $t('ifttt.editIfttt.pageTitle') }}<br/>
          <strong v-if="iftttId">{{ getAutomationById(iftttId).name }}</strong>
        </div>
        <div v-else>
          {{  $t('ifttt.editIfttt.loading') }}
        </div>
        <div type="button" class="modal-close-button" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far fa-times-circle"></i></span> {{  $t('ui.close') }}
        </div>
      </div>
    </template>

    <template #body>
      <div class="ifttt-details">
        <template v-if="iftttId">
          <template v-if="getAutomationById(iftttId)">
            <IftttForm @closeModal="closeModal($event)" :originalIfttt="getAutomationById(iftttId)"></IftttForm>
          </template>
          <div v-else>{{  $t('ifttt.editIfttt.notFound') }}</div>
        </template>
        <template v-else>
          <i class="fas fa-spinner fa-spin"></i>
        </template>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/general/Modal.vue";
import {mapGetters} from "vuex";
import IftttForm from "@/components/ifttt/IftttForm.vue";

export default {
  name: "EditIfttt",
  props: ['modalId'],
  data() {
    return {
      iftttId: null
    }
  },
  components: {
    IftttForm,
    Modal
  },
  computed: {
    ...mapGetters('ifttt', ['getAutomationById'])
  },
  methods: {
    opened(event) {
      this.iftttId = event.iftttId;
    },
    closed() {
      this.iftttId = null;
    },
    closeModal($event) {
      window.$('#' + this.modalId).modal('hide');
      this.swalToastSuccess(this.$t('ifttt.editIfttt.saved'));
    }
  }
}
</script>

<style scoped>

.ifttt-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  width: 100%;
}

.ifttt-header-info {
  display: inline-block;
}

.ifttt-header {
  color: black;
}

</style>